import { Models } from '../../../types'
import Crud from './crud'

const { state, getters, actions, mutations } = new Crud<Models.Vehiculo>()

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
